var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper text-left"},_vm._l((_vm.files),function(file){return _c('v-chip',{key:file.id,staticClass:"attachment",attrs:{"close":"","color":"blue","small":"","outlined":""},on:{"click:close":function($event){return _vm.confirmDeleteAttachment(file)}}},[_vm._v(" "+_vm._s(file.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }